module.exports = __webpack_public_path__ + "img/1f929.e571e7e.svg";